module.exports = __webpack_public_path__ + "img/Dahlberg-18.de0f2722.jpg";